/* eslint-disable react/jsx-fragments */
import React from 'react';

import { string, number, bool, shape } from 'prop-types';
import { Head } from 'nordic/head';
import ReactDOMServer from 'react-dom/server';
import { Image } from 'nordic/image';
import { Style } from 'nordic/style';
import Iframe from '../iframe';

import IconFactory from '../icons/factory-builder';
import { DEFAULT_YOUTUBE_CONFIG } from './constants';

const DEFAULT_VALUE = {};

const IframeImage = ({ url = '', picture = DEFAULT_VALUE }) => (
  <React.Fragment>
    <Style>
      {`
          *{padding:0;margin:0;overflow:hidden}
          html,body{height:100%}
          img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto;}
          span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}
        `}
    </Style>
    <a href={`${url}&autoplay=1&mute=1`}>
      <Image lazyload="off" src={picture.src2x ? picture.src2x : picture.src} alt={picture.alt} id="pdpImageVideo" />
      <span>▶</span>
    </a>
  </React.Fragment>
);

const Figure = ({
  className = null,
  url,
  id = null,
  index = null,
  config = DEFAULT_YOUTUBE_CONFIG,
  lazyload = false,
  ...rest
}) => {
  const parsedUrl = new URL(url);
  const baseUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}`;
  const paramSrc = lazyload
    ? {
        srcDoc: null,
      }
    : {
        src: url,
      };

  if (lazyload) {
    const picture = {
      id,
      src: rest.thumbnail,
    };
    paramSrc.srcDoc = ReactDOMServer.renderToString(<IframeImage url={url} picture={picture} />);
  }

  return (
    <React.Fragment>
      <Head>
        <link rel="preconnect" href={baseUrl} />
      </Head>
      <Iframe
        id="iframe"
        zoom={rest.zoom}
        {...paramSrc}
        className={className}
        loading="lazy"
        {...config}
        scrolling="no"
        data-index={index}
        data-testid={`image-${id}`}
      />
    </React.Fragment>
  );
};

const Icon = ({ className = null, id = 'YOUTUBE_VIDEO', color = 'BLUE' }) => (
  <div className={className}>{IconFactory({ id, color })}</div>
);

const Preview = ({ className = null, thumbnail, alt = 'Video' }) => (
  <Image className={className} lazyload="on" src={thumbnail} alt={alt} />
);

IframeImage.propTypes = {
  url: string,
  picture: shape({
    id: string.isRequired,
    lazyload: bool,
    src: string.isRequired,
    src2x: string,
  }),
};

Figure.propTypes = {
  className: string,
  url: string.isRequired,
  id: string,
  index: number,
  config: shape({
    alt: string,
    title: string,
    allow: string,
    frameBorder: number,
    showSpinner: bool,
  }),
  lazyload: bool,
  picture: shape({
    id: string.isRequired,
    lazyload: bool,
    src: string.isRequired,
    src2x: string,
  }),
  zoomSrc: string,
};

Icon.propTypes = {
  id: string,
  color: string,
  className: string,
};

Preview.propTypes = {
  className: string,
  thumbnail: string.isRequired,
  alt: string,
};

const FigureMemo = React.memo(Figure);

export { FigureMemo, Icon, Preview };
